import Profile from '../../components/profile';

const ProfilePage = () => {
  return <Profile />;
};

export default ProfilePage;
